export default "__VITE_ASSET__BFgZ6GM___"